<template>
    <LoaderSplash :loaded="loaded">
        <b-container v-if="loaded">
            <b-row>
                <b-col>
                    <router-link class="my-3 d-inline-block" :to="{ name: 'event', params: { id: event.id }}">
                        Back to All Invites
                    </router-link>

                    <h2>
                        Create an invitation to {{ event.name }}
                    </h2>

                    <b-form @submit.prevent="onSubmit">
                        <b-form-group>
<!--                            <label>-->
<!--                                First Name-->
<!--                            </label>-->

                            <b-form-input
                                class="tb-form-field"
                                placeholder="First Name"
                                type="text"
                                v-model="form.first_name"
                                required>    
                            </b-form-input>

<!--                            <label>-->
<!--                                Last Name-->
<!--                            </label>-->

                            <b-form-input
                                class="tb-form-field"
                                placeholder="Last Name"
                                type="text"
                                v-model="form.last_name"
                                required>    
                            </b-form-input>

<!--                            <label>-->
<!--                                Phone-->
<!--                            </label>-->

                            <b-form-input
                                class="tb-form-field"
                                placeholder="Phone"
                                type="text"
                                v-model="form.phone">
                            </b-form-input>

<!--                            <label>-->
<!--                                Email-->
<!--                            </label>-->

                            <b-form-input
                                class="tb-form-field"
                                placeholder="Email"
                                type="text"
                                v-model="form.email"
                                required>    
                            </b-form-input>

                            <div v-for="custom_field in form.custom_fields" :key="custom_field.name">
                                <label>
                                    {{toTitleCase(custom_field.name)}}
                                </label>

                                <b-form-input
                                        type="text"
                                        v-model="custom_field.value">
                                </b-form-input>
                            </div>

                            <b-button type="submit" class="tb-button tb-button--blue tb-button--small">
                                Create Invite
                            </b-button>
                        </b-form-group>
                    </b-form>

                    <hr class="mt-5">

                    <h3>
                        Or, upload a list of invitations
                    </h3>

                    <p>
                        Upload a CSV list of invitees to add to the current event. </p>
                    <p>
                        The CSV file must have the following columns:
                    </p>
                    <ul>
                        <li v-for="field in required_fields">{{field}}</li>
                    </ul>
                    <p>
                        Please note the first row of the CSV file should contain the column names as listed above
                    </p>
<!--                    <vue-csv-downloader-->
<!--                            :data="csv_invites"-->
<!--                            :fields="required_fields"-->
<!--                            :download-name="csv_filename">-->
<!--                        <b-button class="btn-primary">-->
<!--                            Download Example CSV-->
<!--                        </b-button>-->
<!--                    </vue-csv-downloader>-->


                    <p>
                        <i class="fa fa-exclamation-circle take-note"></i>
                        Do not send invites to generic email boxes (sales@example.com, info@example.com), they will probably get marked as spam and can affect the delivery of all your other invites
                    </p>

                    <b-form @submit.prevent="onSubmitCSV">
                        <b-form-group>
                            <b-form-file
                                class="mb-2 tb-form-field"
                                v-model="csv_file"
                                placeholder="Choose a file"
                            >
                            </b-form-file>

                            <b-button type="submit" class="tb-button tb-button--blue tb-button--small" :disabled="disable_csv_button">
                                Upload
                            </b-button>
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </LoaderSplash>
</template>

<script>
    import inviteRepository from "@/repository/invites";
    import eventRepository from "@/repository/events";
    import parser from 'csv-parse/lib/es5'; //important, the regular import breaks IE/Edge as wont transpile properly

    export default {
        props: ['id'],

        data() {
            return {
                form: {
                    event_id: null,
                    first_name: "",
                    last_name: "",
                    phone: "",
                    email: "",
                    custom_fields:[],
                },
                csv_file: null,
                event: null,
                errors: {},
                loaded: false,
                submitting_csv:false,
                default_fields: [ 'first_name', 'last_name', 'phone', 'email'],

            }
        },


        mounted() {
            eventRepository.getById(this.id, {
                include: ['client']
            })
                .then(response => {
                    this.event = response.data;
                    response.data.client.custom_invite_fields.forEach(field => {
                        this.form.custom_fields.push(
                            {
                                name: field.name,
                                value:''
                            }
                        )
                    });
                    this.loaded = true;
                });
        },

        computed:{

            required_fields(){
                //phone is a non required default field, but should still be present in the CSV

                return [...this.default_fields, ...this.allowed_custom_fields];
            },

            allowed_custom_fields(){
                return this.form.custom_fields.map(f=>f.name);
            },


            disable_csv_button(){
                if(this.csv_file && !this.submitting_csv){
                    return false;
                }
                return true;
            }
        },

        methods: {
            onSubmit() {
                this.storeInvite(this.form, 'Form Errors');
            },

            storeInvite(invite, fail_notification_title) {
                invite.event_id = this.event.id;

                inviteRepository.store(invite)
                    .then(response => {
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Invite created',
                            text: 'Invite successfully created.'
                        });

                        this.clear();
                    })
                    .catch(error => {
                        if (error.response.status == 422) {
                            // let e = error.response.data.errors;
                            let e = JSON.parse(error.response.data.message).errors.status;

                            // let errors = Object.keys(e).map(key => {
                            //     return e[key].join("<br/>");
                            // }).join("<br/>");

                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: fail_notification_title,
                                text: e,
                                duration: 10000
                            });
                        }
                    });
            },


            onSubmitCSV() {

                this.submitting_csv = true;

                let required_fields = this.required_fields;

                let reader = new FileReader();
                //reader.readAsBinaryString(this.csv_file);
                reader.readAsText(this.csv_file);
                reader.onloadend = () => {
                    parser(reader.result, {
                        trim:true,
                        columns:true
                    }, (errors, output) => {
                        if (errors !== undefined) {
                            // handle parser errors

                            // TODO: notify?
                            // TODO: log errors?
                        } else {

                            let missing_fields = [];

                            let head = Object.keys(output[0]);

                            for (let field of required_fields) {
                                if (head.indexOf(field) == -1) {
                                    missing_fields.push(field);
                                }
                            }

                            if (missing_fields.length) {
                                this.$notify({
                                    group: 'main',
                                    type: 'error',
                                    title: "Missing Columns Error",
                                    text: "Your CSV file is missing the following columns: " + missing_fields,
                                    duration: 10000
                                });
                                this.submitting_csv = false;
                                return;
                            }

                            // TODO: dedupe array here?

                            for (let row of output) {
                                // create new invite object by matching values
                                // to required fields
                                //row is a flat object
                                //we want an object with default fields (this.default_fields) as top level properties,
                                //and other fields in a custom_fields property:
                                /*
                                    {
                                        first_name:'',
                                        last_name:'',
                                        phone:'',
                                        email:'',
                                        custom_fields:[
                                            {name:'custom_field_name', value:''},
                                            {name:'other_custom_field_name', value:''}
                                            ]
                                    }

                                 */

                                let invite = {
                                    custom_fields: []
                                };
                                Object.keys(row).forEach(key => {
                                    if(this.default_fields.indexOf(key) !== -1){
                                        //we have a top level property, add it
                                        invite[key] = row[key];
                                    }else if(this.allowed_custom_fields.indexOf(key) !== -1){
                                        //we have acustom field, push it
                                        invite.custom_fields.push({
                                            name: key,
                                            value: row[key]
                                        })
                                    }
                                });


                                this.storeInvite(invite, "CSV Row Error");
                            }
                            this.submitting_csv = false;
                        }
                    });
                }
            },  

            toTitleCase(str){
                return str.replace(/_/,' ').replace(/\b\S/g, t => t.toUpperCase());
            },

            clear() {

                //this was causing an error, as it doesnt handle custom fields well
                // for (field in this.form) {
                //     this.form[field] = "";
                // }
                this.form.first_name = "";
                this.form.last_name = "";
                this.form.phone = "";
                this.form.email = "";
                this.form.custom_fields.forEach(cf=>cf.value='');
            }
        }
    }
</script>

<style lang="scss">

    .take-note{
        color: #c42603;
    }

    .custom-file-label {
        background-color: transparent!important;
        border: none!important;
        color: $color-white!important;

        &::after {
            display: none!important;
        }
    }
</style>